export default __webpack_public_path__ + "static/media/bookmark-fill.dc2eb048.svg";